import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import home from "@/views/home/home.vue";
import postList from "@/views/postList/postList.vue";
import postDetails from "@/views/postList/postDetails.vue";
import jobProgress from "@/views/jobProgress/jobProgress.vue";
import confirmWritten from "@/views/jobProgress/confirmWritten.vue";
import writtenScore from "@/views/jobProgress/writtenScore.vue";
import interviewScore from "@/views/jobProgress/interviewScore.vue";
import personCenter from "@/views/personCenter/personCenter.vue";
import modifyInfo from "@/views/personCenter/modifyInfo.vue";
import addResume from "@/views/personCenter/addResume.vue";
import axios from "@/plugins/axios.js";

const RecruitmentActivity = () =>
  import("@/views/recruitmentActivity/index.vue");
const ActivityDetail = () => import("@/views/recruitmentActivity/detail.vue");
const Msg = () => import("@/views/jobProgress/msg.vue");
const ReportInfomation = () =>
  import("@/views/jobProgress/reportInfomation.vue");
const InterviewMsg = () => import("@/views/jobProgress/interviewMsg.vue");
const ZhScore = () => import("@/views/jobProgress/zhScore.vue");

Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
const routes = [
  {
    path: "/home",
    name: "Home",
    alias: "/",
    component: home
  },
  {
    path: "/postList",
    name: "PostList",
    component: postList
  },
  {
    path: "/postDetails",
    name: "PostDetails",
    component: postDetails
  },
  {
    path: "/jobProgress",
    name: "JobProgress",
    component: jobProgress
  },
  {
    path: "/confirmWritten",
    name: "ConfirmWritten",
    component: confirmWritten
  },
  {
    path: "/writtenScore",
    name: "WrittenScore",
    component: writtenScore
  },
  {
    path: "/interviewScore",
    name: "InterviewScore",
    component: interviewScore
  },
  /* 综合成绩查询 */
  {
    path: "/zhScore",
    name: "ZhScore",
    component: ZhScore
  },
  {
    path: "/personCenter",
    name: "PersonCenter",
    component: personCenter
  },
  {
    path: "/modifyInfo",
    name: "ModifyInfo",
    component: modifyInfo
  },
  {
    path: "/addResume",
    name: "AddResume",
    component: addResume
  },
  {
    path: "/recruitmentActivity",
    name: "RecruitmentActivity",
    component: RecruitmentActivity
  },
  //招聘活动详情
  {
    path: "/activityDetail",
    name: "ActivityDetail",
    component: ActivityDetail,
    props: true
  },
  //笔试、面试通知
  {
    path: "/msg",
    name: "Msg",
    component: Msg
  },
  {
    path: "/interviewMsg",
    name: "InterviewMsg",
    component: InterviewMsg
  },
  //查看报到通知
  {
    path: "/reportInfomation",
    name: "ReportInfomation",
    component: ReportInfomation
  },
  {
    path: "*",
    redirect: "/"
  }
];

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  //跳转首页时，判断是否存在ssoticket，若存在，则请求后端单点登录验证
  if (to.name == "Home" && to.query.ssoticket) {
    axios
      .post("/User/logonGrBySsoTicket", {
        ssoticket: to.query.ssoticket
      })
      .then(res => {
        console.log("success");
        console.log(res);
        sessionStorage.setItem("__usersession_uuid", res.__usersession_uuid);
        store.commit("setUserInfo", res);
        sessionStorage.setItem("userInfo", JSON.stringify(res));
        next();
      })
      .catch(err => {
        console.log("error");
        console.log(err);
        next();
      });
  } else {
    const whiteList = [
      "/home",
      "/activityDetail",
      "/recruitmentActivity",
      "/postList"
    ];
    // 访问登录页，放行
    if (whiteList.indexOf(to.path) !== -1) return next();
    // 获取__uid
    const tuidStr = window.sessionStorage.getItem("__usersession_uuid");
    // 没有__uid, 强制跳转到登录页
    if (!tuidStr) {
      next("/home");
      store.commit("openLogin");
    }
    next();
  }
});
export default router;
